<template>
  <div class="video-guide-model">
    <a @click="fnShowModal()" class="button"
      ><i class="las la-play-circle fs-2500 text-danger"></i
    ></a>

    <b-modal ref="modal" size="xl" hide-footer>
      <template #modal-title>
        <h4>{{ title }}</h4>
      </template>
      <div class="d-block">
        <vue-plyr>
          <video
            controls
            crossorigin
            playsinline
            data-poster="/img/logos/logo-with.png"
          >
            <source size="720" :src="url" type="video/mp4" />
          </video>
        </vue-plyr>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'ModelVideoPlaceHolder',
  props: ['propsData', 'title', 'url'],
  components: {},
  data() {
    return {
      errors: {},
      id: '',
      name: '',
      status: ''
    }
  },
  computed: {},
  methods: {
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    }
  }
}
</script>
<style scoped lang="scss">
.video-guide-model {
  .button {
    cursor: pointer;
  }
  .las:hover {
    cursor: pointer;
    color: var(--iq-secondary-hover) !important;
  }
}
</style>
